import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { FleetMaintenanceType } from '../../../types/fleet';
import { FleetMaintenanceTypeForm } from './FleetMaintenanceTypeForm';

type Props = {
  isOpen: boolean;
  selectedMaintenanceType?: FleetMaintenanceType;
  onClose: (update?: boolean) => void;
};

function FleetMaintenanceTypeModal({ onClose, isOpen, selectedMaintenanceType }: Props) {
  const { css } = useStyles();
  const [maintenanceType, setMaintenanceType] = useState<FleetMaintenanceType>();

  useEffect(() => {
    if (!selectedMaintenanceType) {
      setMaintenanceType(undefined);
      return;
    } else {
      setMaintenanceType(selectedMaintenanceType);
    }
  }, [selectedMaintenanceType]);

  return createPortal(
    <Modal
      animate
      closeable
      onClose={() => onClose()}
      isOpen={isOpen}
      size="auto"
    >
      <FlexRow
        gap={0}
        classNames={css({
          justifyContent: 'space-between',
          margin: '6px 2rem 0px 0px',
        })}
      >
        <ModalHeader
          className={css({
            marginBottom: '0 !important',
          })}
        >
          {maintenanceType?.value ?? 'Nuevo tipo'}
        </ModalHeader>
      </FlexRow>
      <ModalBody>
        <FlexColumn
          classNames={css({
            width: '70vw',
            maxWidth: '600px',
            minWidth: '350px',
            boxSizing: 'border-box',
            padding: '1rem',
            borderTop: '1px solid rgb(226, 226, 226)',
            maxHeight: '80vh',
          })}
        >
          <FleetMaintenanceTypeForm
            maintenanceType={maintenanceType}
            onCancel={() => onClose(false)}
            afterSave={() => onClose(true)}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(FleetMaintenanceTypeModal);
